(function () {
  var cajon = document.querySelector('[data-tb-carrito]');
  if (!cajon) return;
  var ajustes = JSON.parse(cajon.querySelector('[data-tb-carrito-ajustes]').textContent);
  var textos = ajustes.textos;
  var contenido = cajon.querySelector('[data-tb-carrito-contenido]');
  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var formato = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' });
  var euros = function (centimos) { return formato.format(centimos / 100); };
  var ocupado = false;
  var error = '';

  var variantePack1 = ajustes.variantes[0];
  var variantePack2 = ajustes.variantes[1];

  function cajasDe(item) {
    var n = parseInt(String(item.variant_title || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) || n < 1 ? 1 : n;
  }

  function pedir(url, datos) {
    return fetch(raiz + url, {
      method: datos ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: datos ? JSON.stringify(datos) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'error');
        return j;
      });
    });
  }

  function obtener() { return pedir('cart.js'); }

  function crear(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function clonar(selector) {
    return cajon.querySelector(selector).content.cloneNode(true);
  }

  function pintar(carrito) {
    var principales = carrito.items;
    var unidades = 0;
    var cajas = 0;
    principales.forEach(function (i) { unidades += i.quantity; cajas += i.quantity * cajasDe(i); });

    document.querySelectorAll('[data-tb-contador]').forEach(function (c) {
      c.textContent = unidades;
      c.hidden = unidades === 0;
    });
    var cuenta = cajon.querySelector('[data-tb-carrito-cuenta]');
    cuenta.textContent = cajas === 0 ? '' : (cajas === 1 ? textos.caja : textos.cajas.replace('[n]', cajas));

    contenido.innerHTML = '';
    if (!principales.length) {
      contenido.appendChild(clonar('[data-tb-plantilla-vacio]'));
      return;
    }

    var cuerpo = crear('<div class="tb-carrito__cuerpo"></div>');
    if (error) cuerpo.appendChild(crear('<p class="tb-carrito__error" role="alert">' + escapar(error) + '</p>'));

    principales.forEach(function (item) {
      var indice = ajustes.variantes.map(function (v) { return v.id; }).indexOf(item.variant_id);
      var pack = ajustes.packs[indice] || {};
      var nombre = pack.nombre || item.variant_title || item.product_title;
      var detalle = pack.nombre ? pack.detalle : item.product_title;
      var linea = crear(
        '<div class="tb-carrito__linea">' +
          '<img class="tb-carrito__miniatura" src="' + escapar(ajustes.miniatura || item.image) + '" alt="' + escapar(item.product_title) + '" width="78" height="78">' +
          '<div class="tb-carrito__datos">' +
            '<div class="tb-carrito__nombre-fila"><span class="tb-carrito__nombre">' + escapar(nombre) + '</span><span class="tb-carrito__precio">' + euros(item.final_line_price) + '</span></div>' +
            '<span class="tb-carrito__variante">' + escapar(detalle || '') + '</span>' +
            '<div class="tb-carrito__acciones">' +
              '<div class="tb-selector"><button type="button" data-accion="restar" aria-label="' + escapar(textos.restar) + '">−</button><span aria-live="polite">' + item.quantity + '</span><button type="button" data-accion="sumar" aria-label="' + escapar(textos.sumar) + '">+</button></div>' +
              '<button type="button" class="tb-quitar" data-accion="quitar">' + escapar(textos.quitar) + '</button>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
      linea.querySelectorAll('[data-accion]').forEach(function (b) {
        b.addEventListener('click', function () {
          var accion = b.getAttribute('data-accion');
          var cantidad = accion === 'sumar' ? item.quantity + 1 : accion === 'restar' ? item.quantity - 1 : 0;
          cambiar(item.key, cantidad);
        });
      });
      cuerpo.appendChild(linea);
    });

    cuerpo.appendChild(clonar('[data-tb-plantilla-regalos]'));

    if (variantePack1 && variantePack2) {
      var diferencia = variantePack2.precio - variantePack1.precio;
      var ahorro = variantePack1.precio * 2 - variantePack2.precio;
      var conPack1 = principales.filter(function (i) { return i.variant_id === variantePack1.id; })[0];
      var conPack2 = principales.filter(function (i) { return i.variant_id === variantePack2.id; })[0];
      if (conPack1) {
        var mejora = crear(
          '<div class="tb-mejora">' +
            '<span class="tb-mejora__insignia">' + escapar(textos.mejora_insignia) + '</span>' +
            '<div class="tb-mejora__texto"><b>' + escapar(textos.mejora_titulo.replace('[diferencia]', euros(diferencia))) + '</b><span>' + escapar(textos.mejora_detalle.replace('[ahorro]', euros(ahorro))) + '</span></div>' +
            '<button type="button" class="tb-mejora__boton">' + escapar(textos.mejora_boton) + '</button>' +
          '</div>'
        );
        mejora.querySelector('button').addEventListener('click', function () { mejorar(conPack1); });
        cuerpo.appendChild(mejora);
      } else if (conPack2 && ahorro > 0) {
        cuerpo.appendChild(crear(
          '<div class="tb-ahorro"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1E7A45" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12.5l5 5L20 6"></path></svg><span>' + escapar(textos.ahorro.replace('[ahorro]', euros(ahorro * conPack2.quantity))) + '</span></div>'
        ));
      }
    }

    contenido.appendChild(cuerpo);
    var resumen = clonar('[data-tb-plantilla-resumen]');
    resumen.querySelector('[data-tb-subtotal]').textContent = euros(carrito.items_subtotal_price);
    resumen.querySelector('[data-tb-total]').textContent = euros(carrito.total_price);
    contenido.appendChild(resumen);
  }

  function trabajar(promesa) {
    ocupado = true;
    cajon.classList.add('tb-cargando');
    return promesa
      .then(function () { error = ''; })
      .catch(function (e) { error = textos.error; console.error(e); })
      .then(obtener)
      .then(function (c) {
        pintar(c);
        document.dispatchEvent(new CustomEvent('tb:carrito', { detail: c }));
        return c;
      })
      .finally(function () {
        ocupado = false;
        cajon.classList.remove('tb-cargando');
      });
  }

  function cambiar(clave, cantidad) {
    if (ocupado) return;
    trabajar(pedir('cart/change.js', { id: clave, quantity: Math.max(0, cantidad) }));
  }

  function mejorar(item) {
    if (ocupado) return;
    var datos = {};
    datos[item.key] = 0;
    trabajar(
      pedir('cart/update.js', { updates: datos }).then(function () {
        return pedir('cart/add.js', { items: [{ id: variantePack2.id, quantity: item.quantity }] });
      })
    );
  }

  window.tbCarrito = {
    refrescar: function () { return trabajar(Promise.resolve()); },
    anadir: function (id, cantidad) {
      return trabajar(pedir('cart/add.js', { items: [{ id: id, quantity: cantidad || 1 }] })).then(function (c) {
        window.tbCajones.abrir(cajon);
        return c;
      });
    }
  };

  window.tbCarrito.refrescar();
})();
